import React from 'react';
import axios from 'axios';
import { Router, Redirect, Switch, Route } from "react-router-dom";
import { createBrowserHistory } from "history";
import {Login, Cambiarpass, Header, MenuMovil, Alerta, Footer} from './componentes/comun/Index';
import Index from './componentes/Index';
import Configuraciones from './componentes/configuraciones/Main';
import Mesa from './componentes/mesa/Main';
import Oficios from './componentes/oficios/Main';
import Personas from './componentes/personas/Main';
import Telegram from './componentes/telegram/Main';
const menu = require('./assets/menu.json');

const history = createBrowserHistory({ basename: '/oficios'});
const DISABLED = true; //modo desarrollo

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state={
      showMenu:false,
      menuIzq:[],
      width:0,
      height:0
    }
    this.onWindowResize = this.onWindowResize.bind(this)
  }

  //backend en localhost o ministerio 
  //CAMBIAR EL FINAL DE URL A NUEVO BACK
  componentDidMount(){
    if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
      localStorage.setItem('apiUrl', 'http://localhost:3001/api/oficios');
    } else {
      localStorage.setItem('apiUrl', 'https://mdh.tierradelfuego.gob.ar/api/oficios');
    }
    const tipo = sessionStorage.getItem('tipo');
    this.setState({tipo})
    this.onWindowResize();
  }

  logged(){
    this.setState({showICL:true});
  }

  unlogged(){
    this.setState({showICL:false});
  }

  onWindowResize(){
    this.setState({
      width: window.innerWidth,
      height: window.innerHeight
    });
    this.forceUpdate();
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.onWindowResize);
  }

  //checkea nivel de acceso con session storage
  checkUser(nivel){
    const token = sessionStorage.getItem('token');
    const tipo = sessionStorage.getItem('tipo');
    if (token !== undefined){
      if (tipo == 4) return true;
      if (nivel === 2 && (tipo == 2 || tipo == 3)) return true;
      if (nivel === 1 && tipo == 1) return true;
      return false;
    } else {
      return false;
    }
  }


  render(){
    const {showMenu,menuIzq,width} = this.state;
    return(
      <Router history={history} className="App">
        <Header
          history={history}
          menu={menu}
          unlogged={() => this.unlogged()}
          abrirMenu={(izq) => this.setState({showMenu:!showMenu, menuIzq:izq})}
        />
        {showMenu &&
          <MenuMovil
            history={history}
            menuIzq={menuIzq}
            cerrarMenu={() => this.setState({showMenu:false})}
          />
        }
        {DISABLED &&                          // MENSAJE DE DESARROLLO
          <Alerta
            tipo="warning"
            mensaje="Sistema en desarrollo"
          />
        }
        <Switch>
          <Route
            path="/mesa"                              //ruta
            component={(props) =>{
                if (this.checkUser(1)) {              //checkea autorizacion
                  return (
                    <Mesa
                      {...props}                      //manda al componente
                      history={history}
                    />
                  )
                } else {
                  return(<Redirect to="/"/>)          //redirige al home
                }
              }
            }
          />
          <Route
            path="/oficios"                              //ruta
            component={(props) =>{
                if (this.checkUser(2)) {              //checkea autorizacion
                  return (
                    <Oficios
                      {...props}                      //manda al componente
                      history={history}
                    />
                  )
                } else {
                  return(<Redirect to="/"/>)          //redirige al home
                }
              }
            }
          />
          <Route
            path="/personas"                              //ruta
            component={(props) =>{
                if (this.checkUser(2)) {              //checkea autorizacion
                  return (
                    <Personas
                      {...props}                      //manda al componente
                      history={history}
                    />
                  )
                } else {
                  return(<Redirect to="/"/>)          //redirige al home
                }
              }
            }
          />
          <Route
            path="/configuraciones"                              //ruta
            component={(props) =>{
                if (this.checkUser(4)) {              //checkea autorizacion
                  return (
                    <Configuraciones
                      {...props}                      //manda al componente
                      history={history}
                    />
                  )
                } else {
                  return(<Redirect to="/"/>)          //redirige al home
                }
              }
            }
          />
          
          <Route
            path="/telegram"
            component={(props) =>
              <Telegram
                history={history}
              />
            }
          />
          <Route
            path="/login"
            component={(props) =>
              <Login
                logged={()=>this.logged()}
                history={history}
              />
            }
          />
          <Route
            path="/cambiarpass"
            component={(props) =>
              <Cambiarpass history={history}/>
            }
          />
          <Route
            exact
            path="/"
            component={(props) =>
              <Index
                width={width}
              />
            }
          />
          <Route path="*">
            <div className="Todo Configuraciones">
              <span style={{margin:20}}>Página no encontrada</span>
            </div>
          </Route>
        </Switch>
        <Footer
          width={width}
          organismo="Ministerio de Desarrollo Humano"
          direccion="Güiraldes 576"
          codPostal="V9410BFR Ushuaia, Argentina"
          telefonos={["+ 54 02901 441100"]}
          redesSociales={{
            facebook:"https://www.facebook.com/MinDesarrolloHumanoTDF/",
            twitter:"https://twitter.com/GobiernoTDF/",
            instagram:"https://www.instagram.com/tierradelfuegogob/"
          }}
        />
      </Router>
    );
  }
}

export default App;
